import React, { useEffect, useMemo, useState } from 'react';
import { Col, Progress, Row } from 'antd';
import classNames from 'classnames';
import { getString } from '@nackle/intl-tools';
import { CaretDownOutlined, CaretUpOutlined, HourglassOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Translate } from '../../../services';
import './styles.less';
import { PaperIcon } from '@nackle/paper';

export const InfoBanner = ( { className, parentTitle, title, description, isLoading, locked, percentComplete, type, imageSrc, backgroundSrc, hidePercentage = false  } ) => {
    const classBase = 'info-banner';
    const [ expand, setExpand ] = useState( false );
    const [ isLongDescription, setIsLongDescription ] = useState( undefined );
    const [ bannerHeight, setBannerHeight ] = useState( undefined );

    const inProgress = useMemo( () => {
        if ( percentComplete > 0 && percentComplete < 100 ) {
            return true;
        } else {
            return false;
        }
    }, [ percentComplete ] );

    const isComplete = useMemo( () => {
        if ( percentComplete == 100 ) {
            return true;
        } else {
            return false;
        }
    }, [ percentComplete ] );

    function handleDescriptionLength() {
        const descElem = document.getElementsByClassName( 'description-content' )[ 0 ];
        if ( descElem !== undefined ) {
            // only after rendering set isLongDescription if content is greater than its container (only once!)
            setIsLongDescription( 3 * 24 * 1.05  < descElem.scrollHeight ); // 3 lines * 24px line height + 5% buffer
        }
    }

    useEffect( () => {
        handleDescriptionLength();
        const infoElem = document.getElementsByClassName( 'info-banner' )[ 0 ];
        if ( infoElem !== undefined && expand === false ) {
            setBannerHeight( infoElem.clientHeight );
        }
    } );

    useEffect( () => {
        window.addEventListener( 'resize', () => handleDescriptionLength() );
    }, [] );

    return (
        <div className={ classNames( classBase, className, type, { expand } ) } style={ { minHeight: `${ bannerHeight }px`, backgroundImage: backgroundSrc && `url('${ backgroundSrc }')` } } >
            <Row>
                <Col 
                    className={ `${ classBase }-content` }
                    xs={ 24 }
                    sm={ 24 }
                    md={ 12 }
                    lg={ 12 }
                    xl={ 12 }
                >
                    { parentTitle && 
                        <span className='parentTitle subtitle'>
                            { parentTitle }
                        </span>
                    }

                    <span className='title'>
                        { title }
                    </span>
                    
                    { description && 
                        <div className='description'>
                            <span className={ classNames( 'description-content', { expand: expand } ) } dangerouslySetInnerHTML={ { __html: description } }/>
                            { ( isLongDescription || expand ) && 
                                <p className='expand-trigger' onClick={ () => {setExpand( !expand ); } } >
                                    { expand ? 
                                        <><Translate.Text value="header.showLess" /><CaretUpOutlined/></> 
                                    : 
                                        <><Translate.Text value="header.showMore" /><CaretDownOutlined /></> }
                                </p> }
                        </div> }
                        
                    { !isLoading && !isNaN( percentComplete ) && !hidePercentage &&
                        <div className='progress'>
                        { `${ Math.trunc( percentComplete ) }%` }
                    
                            <Progress
                                size="small"
                                showInfo={ false } 
                                percent={ percentComplete }
                            />
                        </div>
                    }

                    { hidePercentage && (
                        locked ?
                        <div className="progress-text">
                            <PaperIcon collection='ultimate' icon='Lock4' />
                            <span>{ getString( 'learningObject.actions.locked' ) }</span>
                        </div> :
                        inProgress ?
                        <div className="progress-text">
                            <HourglassOutlined/>
                            <span>{ getString( 'progress.missions.inProgress' ) }</span>
                        </div> :
                        isComplete ?
                        <div className="progress-text">
                            <CheckCircleOutlined className='completed' />
                            <span>{ getString( 'progress.missions.complete' ) }</span>
                        </div> : <></> )
                    }

                </Col> 

                <Col 
                    className='header-image'
                    xs={ 0 }
                    sm={ 0 }
                    md={ 12 }
                    lg={ 12 }
                    xl={ 12 }
                >
                    { imageSrc && !isLoading && <img style={ { height: `${ bannerHeight }px` } } src={ imageSrc }/> }
                </Col> 
            </Row>
        </div>
    );
};